/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ответ с данными для формы персональной информации
 * @export
 * @interface FxIdWebFeaturesStoreGetPiFormDataResponse
 */
export interface FxIdWebFeaturesStoreGetPiFormDataResponse {
    /**
     * Публичный идентификатор заказа
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    OrderPublicId: string;
    /**
     * URL для редиректа после успешной отправки формы
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    RedirectUrl: string;
    /**
     * Название продукта
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    ProductName: string;
    /**
     * Описание продукта
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    ProductDescription: string;
    /**
     * SKU продукта
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    Sku: string;
    /**
     * URL изображения продукта
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    ImageUrl: string;
    /**
     * URL иконки продукта
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    IconUrl: string;
    /**
     * Сумма заказа
     * @type {number}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    OrderPriceSum: number;
    /**
     * Валюта заказа
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    OrderPriceCurrency: string;
    /**
     * Локализованная цена заказа
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    OrderLocalizedPrice: string;
    /**
     * Placeholder для поля email
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    EmailPlaceholder?: string | null;
    /**
     * Placeholder для поля телефона
     * @type {string}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    PhonePlaceholder?: string | null;
    /**
     * Компактный режим формы
     * @type {boolean}
     * @memberof FxIdWebFeaturesStoreGetPiFormDataResponse
     */
    Compact: boolean;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreGetPiFormDataResponse interface.
 */
export function instanceOfFxIdWebFeaturesStoreGetPiFormDataResponse(value: object): value is FxIdWebFeaturesStoreGetPiFormDataResponse {
    if (!('OrderPublicId' in value) || value['OrderPublicId'] === undefined) return false;
    if (!('RedirectUrl' in value) || value['RedirectUrl'] === undefined) return false;
    if (!('ProductName' in value) || value['ProductName'] === undefined) return false;
    if (!('ProductDescription' in value) || value['ProductDescription'] === undefined) return false;
    if (!('Sku' in value) || value['Sku'] === undefined) return false;
    if (!('ImageUrl' in value) || value['ImageUrl'] === undefined) return false;
    if (!('IconUrl' in value) || value['IconUrl'] === undefined) return false;
    if (!('OrderPriceSum' in value) || value['OrderPriceSum'] === undefined) return false;
    if (!('OrderPriceCurrency' in value) || value['OrderPriceCurrency'] === undefined) return false;
    if (!('OrderLocalizedPrice' in value) || value['OrderLocalizedPrice'] === undefined) return false;
    if (!('Compact' in value) || value['Compact'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreGetPiFormDataResponseFromJSON(json: any): FxIdWebFeaturesStoreGetPiFormDataResponse {
    return FxIdWebFeaturesStoreGetPiFormDataResponseFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreGetPiFormDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreGetPiFormDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'OrderPublicId': json['OrderPublicId'],
        'RedirectUrl': json['RedirectUrl'],
        'ProductName': json['ProductName'],
        'ProductDescription': json['ProductDescription'],
        'Sku': json['Sku'],
        'ImageUrl': json['ImageUrl'],
        'IconUrl': json['IconUrl'],
        'OrderPriceSum': json['OrderPriceSum'],
        'OrderPriceCurrency': json['OrderPriceCurrency'],
        'OrderLocalizedPrice': json['OrderLocalizedPrice'],
        'EmailPlaceholder': json['EmailPlaceholder'] == null ? undefined : json['EmailPlaceholder'],
        'PhonePlaceholder': json['PhonePlaceholder'] == null ? undefined : json['PhonePlaceholder'],
        'Compact': json['Compact'],
    };
}

export function FxIdWebFeaturesStoreGetPiFormDataResponseToJSON(json: any): FxIdWebFeaturesStoreGetPiFormDataResponse {
    return FxIdWebFeaturesStoreGetPiFormDataResponseToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreGetPiFormDataResponseToJSONTyped(value?: FxIdWebFeaturesStoreGetPiFormDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'OrderPublicId': value['OrderPublicId'],
        'RedirectUrl': value['RedirectUrl'],
        'ProductName': value['ProductName'],
        'ProductDescription': value['ProductDescription'],
        'Sku': value['Sku'],
        'ImageUrl': value['ImageUrl'],
        'IconUrl': value['IconUrl'],
        'OrderPriceSum': value['OrderPriceSum'],
        'OrderPriceCurrency': value['OrderPriceCurrency'],
        'OrderLocalizedPrice': value['OrderLocalizedPrice'],
        'EmailPlaceholder': value['EmailPlaceholder'],
        'PhonePlaceholder': value['PhonePlaceholder'],
        'Compact': value['Compact'],
    };
}

